import { css } from 'aphrodite';
import * as React from 'react';
import { DayPicker } from '../../../web/components/DayPicker';
import { PopoverType, TinyPopover } from '../../../web/components/TinyPopover';
import { XIcon } from '../../../web/components/svgs/icons/XIcon';
import { charmGray } from '../../../web/styles/colors';
import { styleSheet } from './styles';

interface IProps {
	anchor?: React.ReactNode;
	isOpen?: boolean;
	onDaySelected?(day: Date): void;
	onRequestClose?(): void;
	selectedDay?: Date;
}

export class NextMeetingPopover extends React.Component<IProps> {
	public render() {
		const { anchor, isOpen, onDaySelected, onRequestClose, selectedDay } = this.props;
		return (
			<TinyPopover
				align='center'
				anchor={anchor}
				arrow={{
					arrowColor: '#f2f2f2',
					arrowSize: 10,
					arrowStyle: { display: 'block' },
				}}
				dismissOnOutsideAction={true}
				isOpen={isOpen}
				onRequestClose={onRequestClose}
				placement={['top']}
				type={PopoverType.white}
			>
				<div>
					<span className={css(styleSheet.nextMeetingHeader)}>
						When is your next meeting with the client?
						<button onClick={onRequestClose}>
							<XIcon color={charmGray} height={12} width={12} />
						</button>
					</span>
					<DayPicker allowPastDates={false} onDayClick={onDaySelected} selectedDays={selectedDay || new Date()} />
				</div>
			</TinyPopover>
		);
	}
}
